// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1P56r","content":"styles_content__3DGhi","checkbox":"styles_checkbox__2j8HI","checkboxLabel":"styles_checkboxLabel__3fc3x"};